<div class="d-flex gap-2" [class]="groupClass()">
  @if (resolvedActions().length > limit()) {
    <button mat-stroked-button [matMenuTriggerFor]="overflowMenu" [disabled]="disabled()" class="secondary-btn icon-btn"
      (click)="$event.stopPropagation()">
      <pf-icon icon="more_vert"></pf-icon>
    </button>
    <mat-menu #overflowMenu="matMenu" xPosition="before" class="action-group-menu">
      @for (slot of overflowMenuItems(); track $index) {
        @if (slot.type === 'group') {
          @if ($index > 0) {
            <mat-divider></mat-divider>
          }
          <div class="menu-group-label h6 gray text-uppercase px-3 pt-2 pb-1">{{ slot.label }}</div>
          @for (entry of slot.actions; track entry.menuIndex) {
            <pf-action [menuItem]="true" [action]="menuAction(entry.action)" [disabled]="isActionDisabled(entry.action)"
              [tooltip]="getActionTooltip(entry.action)"
              [actionClicked]="actionIndex() === ('MENU' + entry.menuIndex)"
              (onAction)="actionClick(entry.action, entry.menuIndex, $event, true, false)"></pf-action>
          }
        } @else {
          <pf-action [menuItem]="true" [action]="menuAction(slot.action)" [disabled]="isActionDisabled(slot.action)"
            [tooltip]="getActionTooltip(slot.action)"
            [actionClicked]="actionIndex() === ('MENU' + slot.menuIndex)"
            (onAction)="actionClick(slot.action, slot.menuIndex, $event, true, false)"></pf-action>
        }
      }
    </mat-menu>
  }
  @for (action of displayActions(); track action.name || action.icon) {
    @if (!action.show || action.show(componentRef())) {
      @if (action.actions?.length) {
        <button mat-stroked-button [matMenuTriggerFor]="submenu" [disabled]="disabled()"
          (click)="$event.stopPropagation(); setSubmenuActions(action.actions ?? [])"
          [class]="action.class ?? 'secondary-btn icon-btn'">
          @if (action.icon) {
            <pf-icon [icon]="typeof action.icon === 'function' ? action.icon(componentRef()) : action.icon"
              [cssClass]="(action.iconClass ?? 'ic-20') + ' mr-0'"></pf-icon>
          }
          @if (action?.name) {
            <span class="ml-2">{{ action.name }}</span>
          }
        </button>
        <mat-menu #submenu="matMenu" xPosition="before" class="action-group-menu">
          @for (slot of submenuContentItems(); track $index) {
            @if (slot.type === 'group') {
              @if ($index > 0) {
                <mat-divider></mat-divider>
              }
              <div class="menu-group-label h6 gray text-uppercase px-3 pt-2 pb-1">{{ slot.label }}</div>
              @for (entry of slot.actions; track entry.menuIndex) {
                <pf-action [menuItem]="true" [action]="menuAction(entry.action)" [disabled]="isActionDisabled(entry.action)"
                  [tooltip]="getActionTooltip(entry.action)"
                  [actionClicked]="actionIndex() === ('SUBMENU' + entry.menuIndex)"
                  (onAction)="actionClick(entry.action, entry.menuIndex, $event, true, true)"></pf-action>
              }
            } @else {
              <pf-action [menuItem]="true" [action]="menuAction(slot.action)" [disabled]="isActionDisabled(slot.action)"
                [tooltip]="getActionTooltip(slot.action)"
                [actionClicked]="actionIndex() === ('SUBMENU' + slot.menuIndex)"
                (onAction)="actionClick(slot.action, slot.menuIndex, $event, true, true)"></pf-action>
            }
          }
        </mat-menu>
      } @else if (action.toggle) {
        <mat-slide-toggle color="primary" [checked]="getToggleChecked(action)" [matTooltip]="action.toggle?.tooltip" matTooltipClass="bg-black-pearl-tooltip" matTooltipPosition="above"
          (click)="$event.stopPropagation()" [disabled]="isActionDisabled(action)"
          (change)="onToggleChange(action, $event)"></mat-slide-toggle>
      } @else {
        <pf-action [action]="action" [disabled]="isActionDisabled(action)" [isLoading]="isLoading()"
          [tooltip]="getActionTooltip(action)"
          [class.flex-grow-1]="action?.class?.includes('w-100')" [actionClicked]="actionIndex() === ('ROW' + $index)"
          (onAction)="actionClick(action, $index, $event)"></pf-action>
      }
    }
  }
</div>
